import { PhoneField } from '@hypeit-gmbh/hypeit-ui';
import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useContactPrefix } from '../Root';

type PhonePropsType = {
  span?: number;
};

export const Phone: React.FC<PhonePropsType> = ({ span }) => {
  const { t } = useTranslation();
  const prefix = useContactPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <PhoneField
        fieldName={`${prefix}.phone`}
        label={t(`${TRANS_KEY}.PHONE_LABEL`)}
      />
    </Grid.Col>
  );
};
